import { render, staticRenderFns } from "./ChangeOff.vue?vue&type=template&id=774bcd52&scoped=true&"
import script from "./ChangeOff.vue?vue&type=script&lang=js&"
export * from "./ChangeOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774bcd52",
  null
  
)

export default component.exports